import { motion } from 'framer-motion';
import omnitrixLogo from '../../assests/Omnitrix-logo.png';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Projects', href: '#projects' },
  { label: 'Blogs', href: '#blogs' },
  { label: 'Skills', href: '#skills' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="border-t border-white/[0.06] py-10 relative">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Left — Logo */}
          <motion.a
            href="#"
            onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="flex items-center gap-2 group"
          >
            <img src={omnitrixLogo} alt="Omnitrix Logo" className="w-8 h-8 object-contain omnitrix-glow drop-shadow-[0_0_10px_rgba(0,185,46,0.5)]" />
            <span
              className="text-white/60 text-xs tracking-widest hover:text-white transition-colors"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              MD TOUFIQUE
            </span>
          </motion.a>

          {/* Center — Nav links */}
          <div className="flex items-center gap-6">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleClick(e, link.href)}
                className="text-white/30 hover:text-[#00B92E] text-xs transition-colors tracking-wide"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Right — Copyright */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-white/20 text-xs tracking-wide"
          >
            © {new Date().getFullYear()} MD TOUFIQUE
          </motion.p>
        </div>

        {/* Bottom green line */}
        <div className="mt-8 h-px bg-gradient-to-r from-transparent via-[#00B92E]/30 to-transparent" />
      </div>
    </footer>
  );
}